import { FC } from 'react';
import { useCoresPainel } from '@/components/paineis/chartTheme';
import PainelShell from '@/components/paineis/PainelShell';
import PainelVisaoGeral from '@/components/paineis/visaoGeral/PainelVisaoGeral';
import { usePainelFiltrado } from '@/hooks/usePainelFiltrado';
import { dashboardsService } from '@/services/dashboards.service';
import type { VisaoGeralPayload } from '@/types/dashboards';

const buscarVisaoGeral = (params: Record<string, string>) => dashboardsService.getEquiplexVisaoGeral(params);

/**
 * Visão geral da Equiplex (`/paineis/equiplex/visao-geral`) — o "Daily Tracker" do Manus
 * com dado real: S&OP do Balanceamento de Linha × produzido reportado nas OPs, e programado ×
 * produzido por máquina. Lê o último snapshot; nenhuma planilha entra. Período e produto vêm
 * do filtro dos painéis; o mês dentro do período continua escolhido nos chips da aba.
 */
const EquiplexVisaoGeralPage: FC = () => {
  const cores = useCoresPainel();
  const { estado, barra } = usePainelFiltrado<VisaoGeralPayload>(buscarVisaoGeral);
  return (
    <PainelShell
      estado={estado}
      prefixo="vg"
      origem="visao-geral"
      titulo="Visão geral"
      subtitulo="S&OP × realizado no mês de produção (16 a 15) e o programado × produzido de cada máquina."
      corte={(p) => p.corte}
    >
      {({ id, payload }) => (
        <>
          {barra(payload.recorte, undefined, payload.frescor?.dados_ate)}
          <PainelVisaoGeral key={id} payload={payload} cores={cores} />
        </>
      )}
    </PainelShell>
  );
};

export default EquiplexVisaoGeralPage;
